// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Yyb","imageContainer":"e_Zyb","image":"e__yb","content":"e_0yb","title":"e_1yb","bottomLine":"e_2yb","category":"e_3yb","author":"e_4yb","commentsCounter":"e_5yb"};